import { state as stateConstants } from 'src/constants';
import { PROPERTY_FETCH_META } from 'src/core/redux/reducers/constants';

import { selectStateData } from './data';
import selectorConstants from './constants';

export const selectFetchData = (Model, identifier) => (state) => {
  const fetchDataMeta =
    selectStateData(Model.NAME, identifier)(state)?.[PROPERTY_FETCH_META] ||
    selectorConstants.EMPTY_OBJECT;

  return fetchDataMeta;
};

export const selectListFetchData = (Model) => (state) => selectFetchData(
  Model,
  stateConstants.IDENTIFIER_TYPE_LIST
)(state);

export const selectDetailsFetchData = (Model) => (state) => selectFetchData(
  Model,
  stateConstants.IDENTIFIER_TYPE_DETAILS
)(state);
